//import ff from './ff';
import ff from './ff';
import c00d from './c00d_20211115';
import c10d from './c10d_20211115';
import c20d from './c20d_20211115';
import c30d from './c30d_20211115';
import c40d from './c40d_20211115';
import c41d from './c41d_20211115';
import c42d from './c42d_20211115';
import c50d from './c50d_20211115';
import c51d from './c51d_20211115';
import c60d from './c60d_20211115';
import c70d from './c70d_20220623';
import i10d from './i10d_20211115';
import i11d from './i11d_20211115';
//import i13d from './i13d_20211115';
import i14d from './i14d_20211115';
import i15d from './i15d_20211115';
import i16d from './i16d_20211115';
import i1zd from './i1zd_20211115';
import i1yd from './i1yd_20211115';

/*

application id : 2 digit
table main id : 1 digit
table sub id : 1 digit

master:
0123456789abcdefgh

transaction:
ijklmnopqrstuvwxyz

k : kind
r : root
1-9 : child

*/

/*
共通項目
b01k c00m_key
b11k c10m_key
b21k c20m_key
b31k c30m_key
b41k c40m_key
c11s ID
c31s 表記
c32s 正式名
c33s よみ
cx1i 表示順
cy1t 登録日時
cy1k 登録者
s11i 状況
k11i 種別
g11i 分類・区分
i___ 個別項目
*/

export default class iElm {

static d_elmDefs = {
  
  ...c00d.d_defs,
  ...c10d.d_defs,
  ...c20d.d_defs,
  ...c30d.d_defs,
  ...c40d.d_defs,
  ...c41d.d_defs,
  ...c42d.d_defs,
  ...c50d.d_defs,
  ...c51d.d_defs,
  ...c60d.d_defs,
  ...c70d.d_defs,
  ...i10d.d_defs,
  ...i11d.d_defs,
  ...i14d.d_defs,
  ...i15d.d_defs,
  ...i16d.d_defs,
  ...i1zd.d_defs,
  ...i1yd.d_defs,
};

};
